import axios from '../axios'

export default class ContactUs {
  async Insert(data, headers = {}) {
    try {
      const response = await axios.post(`/contact-us`, data, headers);
      return response.data;
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;
      }
    }
  }
}
